import { ScrollEvent } from './component-view-dispatcher'
import { SearchCard100 } from '@at/track-types/dist/types'
import { getCommonComponentContexts, TrackingContext } from '../../utils/tracking/tracking'
import type { TrackViewInteractionCallback } from '../../hooks/tracking/useTrackViewedInteraction.hook'
import { SessionKeys } from '../../utils/session-keys'
import { uuidProvider } from './uuid-provider'
import { searchEntity } from '../../utils/tracking/search'

export function sendComponentViewedEvent(event: ScrollEvent, trackInteraction: TrackViewInteractionCallback): void {
    if (document.hasFocus() && !!event) {
        const searchCardEvent: SearchCard100 = {
            SCHEMA_KEY: 'SearchCard100',
            search_version_id: event.trackingContext?.advertContext?.searchVersionId || undefined,
            position: event.trackingContext?.card.position || 0,
            listing_type: event.listingType,
        }
        const commonComponentContexts = getCommonComponentContexts({
            ...event.trackingContext,
        } as TrackingContext)

        const entitiesToReplace = []
        if (event.trackingContext?.card.pageNumber) {
            const searchId = sessionStorage.getItem(SessionKeys.SEARCH_ID) ?? uuidProvider.getUUID()
            entitiesToReplace.push(searchEntity(searchId, event.trackingContext?.card.pageNumber))
        }

        trackInteraction({
            additionalEntities: [...commonComponentContexts, searchCardEvent, ...entitiesToReplace],
            entitiesToReplace,
        })
    }
}
